import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import Api from "../api/Api";
import AdvancedList from "../controls/AdvancedList";
import SortButton from "../controls/SortButton";
import Page from "../layout/Page";
import Form from "../controls/Form";
import Input from "../controls/Input";
import Confirm from "../layout/Confirm";

export default function CategoryList() {

	const { type } = useParams();

	const [categories, setCategories] = useState(null);
	const [editCategory, setEditCategory] = useState(null);
	const form = useRef();

	useEffect(() => {
		Api.put('categories/getcategories', { type: type }, loadData);
	}, []);

	const loadData = response => {
		setEditCategory(null);
		setCategories([{ id: 'new', name: '', fixed: 1 }].concat(response.data.categories));
	}

	const deleteCategory = () => {
		Confirm(() => {
			Api.put('categories/deletecategory', { Id: editCategory.id + '', type: type }, loadData);
		});
	}

	const renderHeader = <tr>
		<th><SortButton name="name" propertyName="name">{t.commonName}</SortButton></th>
		<th width="40"></th>
		<th width="40"></th>
	</tr>

	const renderRow = (category) => {
		if (editCategory == category)
			return <tr key={category.id}>
				<td><Input name="Name" value={category.name} required /></td>
				<td valign="middle">{category.id == 'new'
					? <span className="pointer fa-solid fa-xmark" onClick={() => setEditCategory(null)}></span>
					: <span className={"fa-solid fa-trash-can " + (!category.canBeDeleted ? "text-muted" : "pointer")} onClick={category.canBeDeleted && deleteCategory}></span>}</td>
				<td valign="middle">
					<Input type="hidden" name="Id" value={editCategory.id} />
					<button type="submit" className="border-0 p-0 fa-solid fa-save"></button>
				</td>
			</tr>;
		else if (category.id != 'new')
			return <tr key={category.id}>
				<td colSpan="2">{category.name}</td>
				<td><span className="pointer fa-solid fa-edit" onClick={() => setEditCategory(category)}></span></td>
			</tr>;
	}

	const actions = [<span onClick={() => setEditCategory(categories[0])} className="btn btn-sm btn-primary"><i className="fa-solid fa-add"></i> {t.categoryNew}</span>];

	return (
		<Page title={T('category' + type.capitalize())} actions={actions}>
			<Form action="categories/savecategory" onSuccess={loadData} ref={form}>
				<Input type="hidden" name="type" value={type} />
				<AdvancedList
					data={categories}
					header={renderHeader}
					renderRow={renderRow}
					searchProperties={["name"]}
					fixedPropertyName="fixed"
					name={type}
				/>
			</Form>
		</Page>
	);
}